import { createAccordion } from "@melt-ui/svelte";
import { getContext, setContext } from "svelte";
import { createBitAttrs, getOptionUpdater, removeUndefined } from "../../internal/index.js";
const NAME = "accordion";
const ITEM_NAME = "accordion-item";
const PARTS = ["root", "content", "header", "item", "trigger"];
export const getAttrs = createBitAttrs(NAME, PARTS);
export function setCtx(props) {
    const accordion = createAccordion(removeUndefined(props));
    setContext(NAME, accordion);
    return {
        ...accordion,
        updateOption: getOptionUpdater(accordion.options)
    };
}
export function getCtx() {
    return getContext(NAME);
}
export function setItem(props) {
    setContext(ITEM_NAME, { ...props });
    const { elements: { item } } = getCtx();
    return { item, props };
}
export function getItemProps() {
    const itemProps = getContext(ITEM_NAME);
    return itemProps;
}
export function getContent() {
    const { elements: { content }, helpers: { isSelected }, states: { value } } = getCtx();
    const { value: props } = getItemProps();
    return { content, props, isSelected, value };
}
export function getTrigger() {
    const { elements: { trigger } } = getCtx();
    const { value, disabled } = getItemProps();
    return { props: { value, disabled }, trigger };
}
